"use client";

import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { useState } from "react";

export function useReCaptcha() {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const generateReCaptchaToken = async () => {
    setIsLoading(true);
    setError(null);

    try {
      if (!executeRecaptcha) {
        throw new Error("ReCaptcha not initialized");
      }

      // Execute reCAPTCHA with the specified action
      const token = await executeRecaptcha();
      setIsLoading(false);
      return token;
    } catch (err) {
      setError(
        err instanceof Error
          ? err.message
          : "Failed to generate reCAPTCHA token",
      );
      setIsLoading(false);
      return null;
    }
  };

  return {
    generateReCaptchaToken,
    isLoading,
    error,
  };
}
